import { Stack } from "@mui/material";
import { ExecutionHistoryCard } from "features/dt-plus-setup/components/history/ExecutionHistoryCard";
import { ProcessingJobsCard } from "features/dt-plus-setup/components/history/ProcessingJobsCard";
import { RunExecutionCard } from "features/dt-plus-setup/components/run/RunExecutionCard";

type IfcExecutionPanelProps = {
  canRun: boolean;
  canView: boolean;
};

export const IfcExecutionPanel = ({ canRun, canView }: IfcExecutionPanelProps) => {
  return (
    <Stack className="w-full flex-col gap-6">
      {canRun ? <RunExecutionCard className="w-full" /> : null}
      {canView ? <ExecutionHistoryCard className="w-full" /> : null}
      {canView ? <ProcessingJobsCard className="w-full" /> : null}
    </Stack>
  );
};
